// Translator notes: Collocations from Peterson's sentences (engine/src/collocations.ts).
// Each id is an engine note (`notes.add(text, id, args)`); `args` names its arguments in the order the
// strings take them. Collected by translator/notes.ts (import.meta.glob): adding a note means adding it here.
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  collocation: {
    args: ['hv'],
    fi: (a: string[]) => `Sanavalinta: ”${a[0]}” – Peterson käyttää näitä sanoja yhdessä, joten valittiin tämä sana.`,
    en: (a: string[]) => `Word choice: “${a[0]}” – Peterson uses these words together, so this word was chosen.`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
